<script setup>
import { ref, watch } from "vue";

const emit = defineEmits(["fecharTela"]);
const props = defineProps({
  tarefas: Array,
  equipeAcao: Array,
});
const selecionarallTarefas = ref(false);
const Selecionarallmembros = ref(false);
const tarefaSelecionada = ref([]);
const membroSelecionado = ref([]);
watch(
  () => props.tarefas,
  (tasks) => {
    tarefaSelecionada.value = tasks?.map(() => false) || [];
  },
  { immediate: true }
);

watch(
  () => props.equipeAcao,
  (membros) => {
    membroSelecionado.value = membros?.map(() => false) || [];
  },
  { immediate: true }
);
const toggleAllTasks = () => {
  tarefaSelecionada.value = tarefaSelecionada.value.map(
    () => selecionarallTarefas.value
  );
};

const toggleAllMembers = () => {
  membroSelecionado.value = membroSelecionado.value.map(
    () => Selecionarallmembros.value
  );
};

function closeWindow() {
  emit("fecharTela");
}
</script>

<template>
  <section
    class="main"
    @click.self="closeWindow"
  >
    <div class="modal-content">
      <button
        class="btn-close"
        @click="closeWindow"
      ></button>

      <section class="tabela">
        <h4>Lista de tarefas</h4>
        <div class="grid-tabela cabecalho-container">
          <div class="cabecalho">Nome</div>
          <div class="cabecalho">Estado</div>
          <div class="cabecalho">Prioridade</div>
          <div class="cabecalho">Status</div>
        </div>
        <label>
          Marcar todos:
          <input
            type="checkbox"
            class="check"
            v-model="selecionarallTarefas"
            @change="toggleAllTasks"
          />
        </label>

        <div class="tarefas-container">
          <div
            class="tarefa-container"
            v-for="(tarefa, index) in props.tarefas"
            :key="tarefa.id"
          >
            <input
              type="checkbox"
              class="check"
              v-model="tarefaSelecionada[index]"
            />
            <div class="grid-tabela linha-tarefa">
              <div class="celula">{{ tarefa.atividadeNome }}</div>
              <div class="celula">{{ tarefa.estadoDescricao }}</div>
              <div class="celula">{{ tarefa.prioridadeDescricao }}</div>
              <div class="celula">{{ tarefa.statusDescricao }}</div>
            </div>
          </div>
        </div>
      </section>

      <section class="tabela">
        <h4>Lista de membros</h4>
        <div class="grid-tabela cabecalho-container">
          <div class="cabecalho">Nome</div>
          <div class="cabecalho">Função</div>
          <div class="cabecalho">Atividades inscritas</div>
          <div class="cabecalho">Horas trabalhadas</div>
        </div>
        <label>
          Marcar todos:
          <input
            type="checkbox"
            class="check"
            v-model="Selecionarallmembros"
            @change="toggleAllMembers"
          />
        </label>

        <div class="tarefas-container">
          <div
            class="tarefa-container"
            v-for="(membro, index) in props.equipeAcao"
            :key="membro.id"
          >
            <input
              type="checkbox"
              class="check"
              v-model="membroSelecionado[index]"
            />
            <div class="grid-tabela linha-tarefa">
              <div class="celula">{{ membro.nome }}</div>
              <div class="celula">{{ membro.funcaoMembro }}</div>
              <div class="celula">100</div>
              <div class="celula">10h</div>
            </div>
          </div>
        </div>
      </section>

      <button
        class="btn-adicionar"
        :style="{
          backgroundColor: 'var(--roxo-primario)',
          color: 'var(--branco)',
        }"
      >
        Adicionar membros
      </button>
    </div>
  </section>
</template>

<style scoped>
.main {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: hsla(0, 0%, 0%, 0.7);
  z-index: 1000;
  & .modal-content {
    background: var(--roxo-medio);
    padding: 0;
    border-radius: 8px;
    max-width: 80%;
    max-height: 80vh;
    height: 80vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: row;
    flex-wrap: wrap;
    & .btn-close {
      position: absolute;
      top: 0;
      right: 0;
    }
    & .btn-adicionar {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      padding: 10px 20px;
      border-radius: 4px;
      border: none;
      cursor: pointer;
    }
    & .btn-adicionar:hover {
      opacity: 0.9;
      border: 1px groove var(--branco);
    }
    & .tabela {
      max-width: 40%;
      border: 1px solid var(--cinza-claro);
      border-radius: 8px;
      padding: 16px;
      background: var(--roxo-medio);
      display: flex;
      flex-direction: column;
      max-height: 60vh;
      color: var(--branco);
      & h4 {
        text-align: center;
        color: var(--cinza-claro);
      }
      & .grid-tabela {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 7px;
      }
      & .cabecalho-container {
        flex-shrink: 0;
        color: var(--cinza-claro);
        & .cabecalho {
          font-weight: bold;
          padding: 7px;
          text-align: center;
          background-color: var(--roxo-primario);
          border-radius: 0px 0px 10px;
          font-size: 1rem;
        }
      }
      .tarefas-container {
        overflow-y: auto;
        max-height: 500px;
        margin-top: 10px;
        flex-grow: 1;

        scrollbar-width: thin;
        scrollbar-color: var(--roxo-primario) var(--roxo-medio);
        & .tarefa-container {
          margin-bottom: 5px;
          flex-shrink: 0;
          & .linha-tarefa {
            background-color: hsla(0, 0%, 100%, 0.1);
            border-radius: 4px;
            & .celula {
              border-bottom: 1px groove var(--branco);
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 40px;
              margin-bottom: 4px;
              font-size: 0.92rem;
              max-width: 100%;
              padding: 5px;
              word-break: normal;
            }
          }
        }
      }
      .tarefas-container::-webkit-scrollbar {
        width: 8px;
      }

      .tarefas-container::-webkit-scrollbar-track {
        background: var(--roxo-medio);
        border-radius: 10px;
      }

      .tarefas-container::-webkit-scrollbar-thumb {
        background-color: var(--roxo-primario);
        border-radius: 10px;
      }
    }
  }
}

@media (max-width: 768px) {
  .main .modal-content {
    max-width: 95%;
    height: 90vh;
    max-height: 90vh;
    overflow-y: auto;
  }

  .main .modal-content .tabela {
    max-width: 100%;
    width: 100%;
    overflow-x: auto;
  }
}
</style>
